import { render, staticRenderFns } from "./PersonalInformations.vue?vue&type=template&id=8fff106e&"
import script from "./PersonalInformations.vue?vue&type=script&lang=js&"
export * from "./PersonalInformations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports